import ModuleInfoProvider from "./ModuleInfoProvider";
import JWTClient from "./JWTClient";
import JsonApiDeserializer from "./JsonApiDeserializer";
import ConfigService from "./ConfigService";
import trkl from "trkl";
import {newDate} from "../utilities/date";

class MessageServiceClass {
    intervalId;
    observable = trkl(newDate('2000-01-01T00:00:00+0000'));
    badge = trkl(0);

    start = () => {
        if (this.intervalId !== undefined) return;
        this.intervalId = setInterval(this.checkForUpdates, 300000);
    };

    stop = () => {
        if (this.intervalId === undefined) return;
        clearInterval(this.intervalId);
    };

    checkForUpdates = () => {
        if (!ConfigService.userProfile()) return;

        const url = ModuleInfoProvider.getModuleWebServiceUrl('messenger') + '/messages?received=1&draft=0&sortBy=updatedAt&direction=desc&limit=1';
        JWTClient.fetch(url)
            .then(res => {
                const data = JsonApiDeserializer.deserializeItems(res.data, res.included);
                const date = data.length ? newDate(data[0].updatedAt) : new Date();
                if(date.getTime() > this.observable().getTime()) {
                    this.observable(date)
                }
            })
            .catch(() => {})
    };

}

let MessageService = new MessageServiceClass();
export default MessageService;



// WEBPACK FOOTER //
// ./services/MessageService.js